export default "__VITE_ASSET__Cxkg0nF$__"